// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IDistanceEstimationSchema } from './DistanceEstimationSchema';

export interface ICreateUserEstimationRequestV2Schema {
  /** Список техники в квартире **/
  appliances?: EAppliances[];
  /** Оценочная стоимость техники и мебели **/
  appliancesAndFurnitureCost?: number;
  /** Площадь **/
  area: number;
  /** Высота потолков **/
  ceilingHeight?: number;
  /** Возможно проживание с детьми **/
  childrenAllowed?: boolean;
  /** Список опций комфорта **/
  comfort?: EComfort[];
  /** Требуемая срочность совершения сделки **/
  dealPeriod?: EDealPeriod;
  /** Планируемый тип сделки **/
  dealTypeEx?: EDealTypeEx;
  /** Этаж на котором расположена квартира **/
  floor?: number;
  /** Количество этажей в доме **/
  floorMax?: number;
  /** Id дома **/
  houseId: number;
  /** Тип дома (материал постройки) **/
  houseMaterialType?: EHouseMaterialType;
  /** Список объектов городской инфраструктуры рядом с домом **/
  infrastructure?: EInfrastructure[];
  /** Вы агент по недвижимости? **/
  isAgent: boolean;
  /** Планировка квартиры **/
  layout?: string;
  /** Необходимость заключения договора аренды **/
  leaseAgreement?: boolean;
  /** Наличие лоджии или балкона **/
  loggiaOrBalcony?: boolean;
  /** ID объявления **/
  offer?: number;
  /** Производился капитальный ремонт за последние 10 лет **/
  overhaul?: boolean;
  /** Возможно проживание с животными **/
  petsAllowed?: boolean;
  /** Номер телефона пользователя **/
  phone?: string;
  /** Необходимо ли оформить пуш-подписку на оценку **/
  pushNeed?: boolean;
  /** Текущий тип ремонта **/
  repair?: ERepair;
  /** Возраст ремонта **/
  repairAge?: ERepairAge;
  /** Оценочная стоимость ремонта (с учетом ремонта кухни, если он производился) **/
  repairCost?: number;
  /** Кол-во комнат **/
  roomsCount: number;
  /** Идентификатор подписки на оценку **/
  subscriptionId?: number;
  /** Расстояние до ближайшей станции метро (в минутах) **/
  timeToMetro?: IDistanceEstimationSchema;
  /** Почему вас заинтересовала оценка? **/
  valuationReason: EValuationReason;
  /** Необходима помощь риелтора для уточнения оценки **/
  wantRealtor?: boolean;
  /** Вид из окон **/
  windowsView?: EWindowsView;
  /** Список дополнений остающихся в квартире после продажи **/
  withAppliancesOrFurniture?: EWithAppliancesOrFurniture[];
  /** Год постройки дома **/
  yearRelease?: number;
}
export enum EAppliances {
  /** Посудомоечная машина **/
  'Dishwasher' = 'dishwasher',
  /** Телефон **/
  'Phone' = 'phone',
  /** Холодильник **/
  'Refrigerator' = 'refrigerator',
  /** Телевизор **/
  'Tv' = 'tv',
  /** Стиральная машина **/
  'Washer' = 'washer',
}
export enum EComfort {
  /** Ванна **/
  'Bath' = 'bath',
  /** Совмещенный санузел **/
  'CombinedBathroom' = 'combinedBathroom',
  /** Кондиционер **/
  'Conditioner' = 'conditioner',
  /** Интернет **/
  'Internet' = 'internet',
  /** Раздельный санузел **/
  'SeparateBathroom' = 'separateBathroom',
  /** Душевая кабина **/
  'Shower' = 'shower',
}
export enum EDealPeriod {
  /** В течение месяца **/
  'OneMonth' = 'oneMonth',
  /** В течение недели **/
  'OneWeek' = 'oneWeek',
  /** В течение 6 месяцев **/
  'SixMonths' = 'sixMonths',
  /** В течение 3 месяцев **/
  'ThreeMonths' = 'threeMonths',
  /** В течение 12 месяцев **/
  'TwelveMonths' = 'twelveMonths',
  /** В течение 2 недель **/
  'TwoWeek' = 'twoWeek',
}
export enum EDealTypeEx {
  /** Купить **/
  'Buy' = 'buy',
  /** Сдать **/
  'Rent' = 'rent',
  /** Продать **/
  'Sale' = 'sale',
  /** Продать, чтобы купить **/
  'SellToBuy' = 'sellToBuy',
  /** Снять **/
  'Tenant' = 'tenant',
}
export enum EHouseMaterialType {
  /** Блочный **/
  'Block' = 'block',
  /** Кирпичный **/
  'Brick' = 'brick',
  /** Монолитный **/
  'Monolith' = 'monolith',
  /** Монолитно **/
  'MonolithBrick' = 'monolithBrick',
  /** Панельный **/
  'Panel' = 'panel',
  /** Сталинский **/
  'Stalin' = 'stalin',
  /** Деревянный **/
  'Wood' = 'wood',
}
export enum EInfrastructure {
  /** Детский сад **/
  'Kindergarten' = 'kindergarten',
  /** Поликлиника **/
  'Polyclinic' = 'polyclinic',
  /** Школа **/
  'School' = 'school',
  /** Магазин **/
  'Shop' = 'shop',
}
export enum ERepair {
  /** Косметический **/
  'Cosmetic' = 'cosmetic',
  /** Убитый **/
  'Dead' = 'dead',
  /** Дизайнерский **/
  'Design' = 'design',
  /** Евро **/
  'Euro' = 'euro',
  /** Бабушкин **/
  'Old' = 'old',
  /** Без ремонта **/
  'Without' = 'without',
}
export enum ERepairAge {
  /** Более 10 лет **/
  'GtTen' = 'gtTen',
  /** От 5 до 10  лет **/
  'GteFiveLteTen' = 'gteFiveLteTen',
  /** От года до 5 лет **/
  'GteOneLteFive' = 'gteOneLteFive',
  /** Менее года **/
  'LteOne' = 'lteOne',
}
export enum EValuationReason {
  /** Купить **/
  'Buy' = 'buy',
  /** Просто интересно **/
  'Interest' = 'interest',
  /** Сдать **/
  'Rent' = 'rent',
  /** Хочу продать квартиру **/
  'Sale' = 'sale',
  /** Продать, чтобы купить **/
  'SellToBuy' = 'sellToBuy',
  /** Снять **/
  'Tenant' = 'tenant',
}
export enum EWindowsView {
  /** На улицу **/
  'Street' = 'street',
  /** Во двор **/
  'Yard' = 'yard',
  /** Во двор и на улицу **/
  'YardStreet' = 'yardStreet',
}
export enum EWithAppliancesOrFurniture {
  /** Техника **/
  'Appliances' = 'appliances',
  /** Мебель **/
  'Furniture' = 'furniture',
}
